module.exports = __webpack_public_path__ + "static/media/apartment.d2217901.jpg";